export const selectPurchaseDetails = state => state.header.purchaseDetails;

export const selectPurchaseDetailsRequestStatus = state => selectPurchaseDetails(state).purchaseDetailsRequestStatus;
